import React, { useState } from 'react';
import {
	useGetList,
	TextField as RaTextField,
	Datagrid,
	ListContextProvider,
	Pagination,
	useListController,
	useRecordContext,
} from 'react-admin';
import {
	Card,
	CardContent,
	Typography,
	TextField as MuiTextField,
	Box,
} from '@mui/material';
import { ConnectorAccountStatusLst } from '../../Services/connectorAccount';

export const ConnectorAccountsList = ({ sku }: { sku: string }) => {
	const [page] = useState(1);
	const [perPage] = useState(10);
	const [search, setSearch] = useState('');

	const { error } = useGetList(
		'connector-accounts',
		{
			pagination: { page, perPage },
			sort: { field: 'connectorAccount.createdAt', order: 'ASC' },
			filter: {
				sku,
				...(search ? { accountId: search } : {}),
			},
		},
		{
			enabled: !!sku,
		}
	);

	const listContextValue = useListController({
		resource: 'connector-accounts',
		filter: { sku, ...(search ? { accountId: search } : {}) },
		sort: { field: 'connectorAccount.createdAt', order: 'ASC' },
		perPage,
	});

	// Fonction qui construit l'URL vers /logs avec les bons filtres
	const handleRowClick = (record: any) => {
		const d = record.split('-');

		const filter = {
			projectFolderId: d[0],
			accountId: d[2],
			sku: d[1],
		};

		console.log('filter', filter);

		const query = new URLSearchParams({
			filter: JSON.stringify(filter),
			order: 'ASC',
			page: '1',
			perPage: '50',
			sort: 'id',
		}).toString();

		return `/logs?${query}`;
	};

	return (
		<Card>
			<CardContent>
				<Typography variant="h6" gutterBottom>
					Connector Accounts
				</Typography>

				<MuiTextField
					label="Search Account ID"
					variant="outlined"
					size="small"
					value={search}
					onChange={(e) => setSearch(e.target.value)}
					style={{ marginBottom: 16 }}
				/>

				{error && (
					<Typography color="error">Erreur lors du chargement</Typography>
				)}

				<ListContextProvider value={listContextValue}>
					<Datagrid rowClick={handleRowClick}>
						<RaTextField source="project.name" />
						<RaTextField source="accountName" />
						<ConnectorStatusField />
						<FormattedDateField source="createdAt" />
					</Datagrid>
					<Pagination />
				</ListContextProvider>
			</CardContent>
		</Card>
	);
};

export const ConnectorStatusField = () => {
	const record = useRecordContext();

	if (!record) return null;

	const status = ConnectorAccountStatusLst.find((s) => s.id === record.status);

	if (!status) return <Typography>Unknown</Typography>;

	return (
		<Box display="inline" padding={0.5}>
			<Typography
				variant="body2"
				sx={{
					color: status.color,
					fontWeight: 600,
				}}
			>
				{status.name}
			</Typography>
		</Box>
	);
};

export const FormattedDateField = ({ source }: { source: string }) => {
	const record = useRecordContext();
	if (!record || !record[source]) return null;

	const dateObj = new Date(record[source]);

	// Format DD/MM/YYYY
	const formatted = dateObj.toLocaleDateString('fr-FR');

	return <Typography variant="body2">{formatted}</Typography>;
};
